<template>
  <div class="modal-card" style="width: auto">
    <div class="modal-card-body">
      <div class="level">
        <div class="level-item">
          <gmap-map :center="location" :zoom="12" style="width:100%; height: 400px;">
            <gmap-marker :position="location"></gmap-marker>
          </gmap-map>
        </div>
      </div>
    </div>
    {{ showMap }}
  </div>
</template>

<script>
export default {
  data () {
    return {
      center: {},
      marker: {
        lat: 24.503418291580818,
        lng: 39.61098560292976
      }
    }
  },
  mounted () {
    this.getMap()
  },
  methods: {
    getMap: function () {
      if (navigator.geolocation) {
        // console.log('yes')
      } else {
        // console.log('no')
      }
      navigator.geolocation.getCurrentPosition(position => {
        if (this.location.lat && this.location.lng) {
          this.center.lat = this.location.lat
          this.center.lng = this.location.lng
          this.marker.lat = this.location.lat
          this.marker.lng = this.location.lng
        } else {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.marker.lat = position.coords.latitude
          this.marker.lng = position.coords.longitude
        }
      })
    }
  },
  props: [
    'location'
  ],
  computed: {
    showMap: function () {
      return this.getMap()
    }
  }
}
</script>
